const persianWithoutNumberFilterOnKeyPress = (e: any) => {
    const charCode = e.charCode
    const value = String.fromCharCode(charCode)
    if (/[\u0600-\u06FF\s]+$/.test(value))
        return true
    else {
        e.preventDefault()
        return false
    }
}
export default persianWithoutNumberFilterOnKeyPress